import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { InputUI, Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'
import { TimezonedDatePicker } from '@modules/Timezone/components/TimezonedDatePicker'

import type {
  FirstSubscribedAtRule as FirstSubscribedAt,
  FormValues,
} from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
}

export const FirstSubscribedAtRule = ({ form, options }: Props) => (
  <div style={{ display: 'grid', gap: 16 }}>
    <RuleLayout
      top={
        <Select
          value={'FirstSubscribedAt' satisfies FirstSubscribedAt['type']}
          label="Requirement to earn badge"
          options={options}
          onValueChange={(value) => {
            const newRules = form.values.rules.map((rule) =>
              rule.type === 'FirstSubscribedAt' ? { type: value } : rule,
            )

            form.setFieldValue(FormFields.rules, newRules)
          }}
        />
      }
      bottom={
        <>
          <TimezonedDatePicker
            labels={['From']}
            dateFormat="MMM D, YYYY, h:mm A"
            showTimeInputs
            value={[
              form.values.firstSubscribedAtFrom
                ? new Date(form.values.firstSubscribedAtFrom)
                : undefined,
            ]}
            maxDate={
              form.values.firstSubscribedAtTo
                ? new Date(form.values.firstSubscribedAtTo)
                : undefined
            }
            onChange={(value) => {
              form.setFieldValue(FormFields.firstSubscribedAtFrom, value[0]?.toISOString())
            }}
            onClear={() => {
              form.setFieldValue(FormFields.firstSubscribedAtFrom, undefined)
            }}
          />
          <TimezonedDatePicker
            labels={['Until']}
            dateFormat="MMM D, YYYY, h:mm A"
            showTimeInputs
            value={[
              form.values.firstSubscribedAtTo
                ? new Date(form.values.firstSubscribedAtTo)
                : undefined,
            ]}
            minDate={
              form.values.firstSubscribedAtFrom
                ? new Date(form.values.firstSubscribedAtFrom)
                : undefined
            }
            onChange={(value) => {
              form.setFieldValue(FormFields.firstSubscribedAtTo, value[0]?.toISOString())
            }}
            onClear={() => {
              form.setFieldValue(FormFields.firstSubscribedAtTo, undefined)
            }}
          />
        </>
      }
      onRemove={() => {
        form.setFieldValue(
          FormFields.rules,
          form.values.rules.filter(
            (rule) => rule.type !== ('FirstSubscribedAt' satisfies FirstSubscribedAt['type']),
          ),
        )
      }}
    />
    {form.errors.firstSubscribedAtTo && (
      <InputUI.Error $withoutMargin>{form.errors.firstSubscribedAtTo}</InputUI.Error>
    )}
  </div>
)
